export interface Bono {
  numero: number;
  titulo: string;
  subtitulo: string;
  bullets: string[];
  valorOriginal: string;
  color: string;
  colorTextDark: string;
}

export const bonos: Bono[] = [
  {
    numero: 1,
    titulo: 'Planificador Anual Mes a Mes',
    subtitulo: '365 días de menú sin repeticiones',
    bullets: ['Estructura por estación', 'Regla del espejo proteico', 'Nunca repites ingredientes'],
    valorOriginal: '€45',
    color: '#10B981',
    colorTextDark: '#047857'
  },
  {
    numero: 2,
    titulo: 'Listas de Compra Inteligentes',
    subtitulo: 'Estrategia Zero Residuos',
    bullets: ['52 listas (una por semana)', 'Cero desperdicios', 'Ahorro garantizado'],
    valorOriginal: '€35',
    color: '#FBBF24',
    colorTextDark: '#92400E'
  },
  {
    numero: 3,
    titulo: 'La Biblia de los Reemplazos',
    subtitulo: '200+ opciones de ingredientes',
    bullets: ['Proteínas intercambiables', 'Verduras, grasas, especias', 'Situaciones especiales'],
    valorOriginal: '€40',
    color: '#F97316',
    colorTextDark: '#EA580C'
  },
  {
    numero: 4,
    titulo: 'Guía para Leer Etiquetas',
    subtitulo: 'Identifica los enemigos ocultos',
    bullets: ['7 enemigos de tu barriga', 'Cómo leer etiquetas realmente', 'Tabla de decisión rápida'],
    valorOriginal: '€30',
    color: '#3B82F6',
    colorTextDark: '#1E40AF'
  },
  {
    numero: 5,
    titulo: 'Diario de Síntomas 12 Semanas',
    subtitulo: 'Tu rastreador personal',
    bullets: ['84 días de seguimiento', 'Autodiagnóstico completo', 'Descubre TUS patrones'],
    valorOriginal: '€25',
    color: '#EC4899',
    colorTextDark: '#BE185D'
  }
];

export const valorTotalBonos = '€175';
